import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { ListItem as ListItem$1, Divider } from "@mui/material";
import { BoxWrapper } from "./styles/containers.es.js";
import { NonInteractive } from "./components/non-interactive.es.js";
import { Interactive } from "./components/interactive.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
function ListItem({
  disablepadding,
  parentid,
  interactive = false,
  divider,
  ...rest
}) {
  const {
    id = "listitem-id"
  } = rest;
  return /* @__PURE__ */ jsxs(BoxWrapper, { disablepadding, "data-testid": parentid, children: [
    /* @__PURE__ */ jsxs(ListItem$1, { alignItems: Alignment.center, id, "data-testid": id, children: [
      !interactive && /* @__PURE__ */ jsx(NonInteractive, { ...rest }),
      interactive && /* @__PURE__ */ jsx(Interactive, { ...rest })
    ] }),
    divider && /* @__PURE__ */ jsx(Divider, {})
  ] });
}
export {
  ListItem
};
//# sourceMappingURL=list-item.es.js.map
